// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2017, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

:root {
  --bolus-stroke: 1;
}

.diabetes--basalScheduledFill--AeDir {
  fill: var(--basal);
  fill-opacity: 0.4;
}

.diabetes--basalAutomatedFill--dEelQ {
  fill: var(--basal-automated);
  fill-opacity: 0.4;
}

.diabetes--basalTempFill--_ZOLa {
  fill: var(--basal);
  fill-opacity: 0.2;
}

.diabetes--basalScheduledPath--Sdgh5 {
  stroke: var(--basal);
}

.diabetes--basalAutomatedPath--zSX75 {
  stroke: var(--basal-automated);
}

.diabetes--basalUndeliveredPath--ee42F {
  stroke-dasharray: 1.5,3;
}

.diabetes--bgVeryLow--KdUfS {
  color: var(--bg-very-low);
  fill: var(--bg-very-low);
}

.diabetes--bgLow--taAIv {
  color: var(--bg-low);
  fill: var(--bg-low);
}

.diabetes--bgTarget--bXo1p {
  color: var(--bg-target);
  fill: var(--bg-target);
}

.diabetes--bgHigh--BIIU5 {
  color: var(--bg-high);
  fill: var(--bg-high);
}

.diabetes--bgVeryHigh--_zmQ3 {
  color: var(--bg-very-high);
  fill: var(--bg-very-high);
}

.diabetes--bolusDelivered--zf59g {
  color: var(--bolus);
  fill: var(--bolus);
}

.diabetes--bolusInterrupted--lm5EM {
  color: var(--bolus--interrupted);
  fill: var(--bolus--interrupted);
}

.diabetes--bolusProgrammed--eNkmM {
  fill: none;
  stroke: var(--bolus);
  stroke-dasharray: 3, 2;
  stroke-width: 1;
  stroke-width: var(--bolus-stroke);
}

.diabetes--bolusRideTriangle--F3D5T {
  fill: var(--bolus--ride);
}

.diabetes--bolusUndelivered--wDu63 {
  color: var(--bolus--undelivered);
  fill: var(--bolus--undelivered);
}

.diabetes--bolusUnderride--nulSA {
  color: var(--bolus--undelivered);
  fill: var(--bolus--undelivered);
}

.diabetes--carbs--YwpFo {
  color: var(--carbs);
  fill: var(--carbs);
}
`, "",{"version":3,"sources":["webpack://./src/styles/diabetes.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,sBAAsB;EACtB,eAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2017, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n:root {\n  --bolus-stroke: 1;\n}\n\n.basalScheduledFill {\n  fill: var(--basal);\n  fill-opacity: 0.4;\n}\n\n.basalAutomatedFill {\n  fill: var(--basal-automated);\n  fill-opacity: 0.4;\n}\n\n.basalTempFill {\n  fill: var(--basal);\n  fill-opacity: 0.2;\n}\n\n.basalScheduledPath {\n  stroke: var(--basal);\n}\n\n.basalAutomatedPath {\n  stroke: var(--basal-automated);\n}\n\n.basalUndeliveredPath {\n  composes: basalScheduledPath;\n  stroke-dasharray: 1.5,3;\n}\n\n.bgVeryLow {\n  color: var(--bg-very-low);\n  fill: var(--bg-very-low);\n}\n\n.bgLow {\n  color: var(--bg-low);\n  fill: var(--bg-low);\n}\n\n.bgTarget {\n  color: var(--bg-target);\n  fill: var(--bg-target);\n}\n\n.bgHigh {\n  color: var(--bg-high);\n  fill: var(--bg-high);\n}\n\n.bgVeryHigh {\n  color: var(--bg-very-high);\n  fill: var(--bg-very-high);\n}\n\n.bolusDelivered {\n  color: var(--bolus);\n  fill: var(--bolus);\n}\n\n.bolusInterrupted {\n  color: var(--bolus--interrupted);\n  fill: var(--bolus--interrupted);\n}\n\n.bolusProgrammed {\n  fill: none;\n  stroke: var(--bolus);\n  stroke-dasharray: 3, 2;\n  stroke-width: var(--bolus-stroke);\n}\n\n.bolusRideTriangle {\n  fill: var(--bolus--ride);\n}\n\n.bolusUndelivered {\n  color: var(--bolus--undelivered);\n  fill: var(--bolus--undelivered);\n}\n\n.bolusUnderride {\n  color: var(--bolus--undelivered);\n  fill: var(--bolus--undelivered);\n}\n\n.carbs {\n  color: var(--carbs);\n  fill: var(--carbs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basalScheduledFill": `diabetes--basalScheduledFill--AeDir`,
	"basalAutomatedFill": `diabetes--basalAutomatedFill--dEelQ`,
	"basalTempFill": `diabetes--basalTempFill--_ZOLa`,
	"basalScheduledPath": `diabetes--basalScheduledPath--Sdgh5`,
	"basalAutomatedPath": `diabetes--basalAutomatedPath--zSX75`,
	"basalUndeliveredPath": `diabetes--basalUndeliveredPath--ee42F diabetes--basalScheduledPath--Sdgh5`,
	"bgVeryLow": `diabetes--bgVeryLow--KdUfS`,
	"bgLow": `diabetes--bgLow--taAIv`,
	"bgTarget": `diabetes--bgTarget--bXo1p`,
	"bgHigh": `diabetes--bgHigh--BIIU5`,
	"bgVeryHigh": `diabetes--bgVeryHigh--_zmQ3`,
	"bolusDelivered": `diabetes--bolusDelivered--zf59g`,
	"bolusInterrupted": `diabetes--bolusInterrupted--lm5EM`,
	"bolusProgrammed": `diabetes--bolusProgrammed--eNkmM`,
	"bolusRideTriangle": `diabetes--bolusRideTriangle--F3D5T`,
	"bolusUndelivered": `diabetes--bolusUndelivered--wDu63`,
	"bolusUnderride": `diabetes--bolusUnderride--nulSA`,
	"carbs": `diabetes--carbs--YwpFo`
};
export default ___CSS_LOADER_EXPORT___;
